import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { connectRouter, routerMiddleware } from "connected-react-router";
import { History } from "history";
import { State, reducers, InitialState } from "./";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export default function configureStore(
  history: History,
  initialState: State = InitialState
) {
  const middleware = [thunk, routerMiddleware(history)];

  const persistConfig = {
    key: "offlineStore",
    storage,
    whitelist: ["offlineData", "selectedTab"]
  };
  const rootReducer = combineReducers({
    ...reducers,
    router: connectRouter(history)
  });
  const pReducer = persistReducer(persistConfig, rootReducer);

  const enhancers = [];
  const windowIfDefined =
    typeof window === "undefined" ? null : (window as any);
  if (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__) {
    enhancers.push(windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__());
  }

  const store = createStore(
    pReducer,
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );

  const persistor = persistStore(store);
  return { persistor, store };
}
